var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "giftLucky"
  }, [_c('div', {
    staticClass: "lucky-body"
  }, [_c('div', {
    staticClass: "lucky-main page-main"
  }, [_c('div', {
    ref: "resultCoinCoincotainerRef",
    staticClass: "luckyTable-coin-coincotainer"
  }), _c('div', {
    staticClass: "lucky-con",
    style: {
      backgroundImage: `url(${require(`@images/tapcoin/lucky/lucky-bg.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "luckyTable"
  }, [_c('div', {
    staticClass: "luckyTable-m"
  }), _c('div', {
    staticClass: "luckyTable-bg",
    style: {
      backgroundImage: `url(${require(`@images/tapcoin/lucky/lucky-item-bg-gift.png`)})`
    }
  }), _c('div', {
    ref: "luckyTableAdroinRef",
    staticClass: "luckyTable-adroin",
    class: _vm.isStartLucky && 'active',
    style: {
      backgroundImage: `url(${require(`@images/${this.theme}/lucky/light1-gift.png`)})`
    }
  }), _vm.isLoadingLuckyList ? _c('div', {
    staticClass: "luckyTable-loading"
  }) : [_vm.prizeList && _vm.prizeList.length > 0 ? _c('div', {
    staticClass: "luckyTable-main",
    attrs: {
      "id": "luckyTableMain"
    }
  }, [_c('lucky-wheel', {
    ref: "vueLuckywheel",
    attrs: {
      "prize-index": _vm.prizeIndex
    },
    on: {
      "get-prize": _vm.onStart,
      "game-over": _vm.onResult
    }
  }, _vm._l(_vm.prizeList, function (prize, index) {
    return _c('lucky-wheel-item', {
      key: index,
      attrs: {
        "oddColor": "#b7a6ff",
        "evenColor": "#784df1"
      }
    }, [_c('div', {
      staticClass: "luckyTable-item"
    }, [_c('div', {
      staticClass: "luckyTable__icon",
      style: {
        backgroundImage: `url(${require(`@images/tapcoin/lucky/${prize.type}.png`)})`
      }
    }), _c('div', {
      staticClass: "luckyTable__num"
    }, [_vm._v("x" + _vm._s(_vm._f("fmt_pre")(prize.value)))])])]);
  }), 1)], 1) : _vm._e()]], 2)]), _c('div', {
    staticClass: "lucky-btns"
  }, [_c('div', {
    staticClass: "lucky-btns-main"
  }, [_c('div', {
    staticClass: "lucky-btn",
    class: (!_vm.isFlag || _vm.luckyInfo.stock.price_stock > 0 && _vm.userData.stock < _vm.luckyInfo.stock.price_stock || _vm.luckyInfo.stock.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.stock.price_coin) && 'active',
    style: {
      background: `url(${require(`@images/${_vm.theme}/new/machine/machine-btn2-bg.png`)}) center/auto 100% no-repeat`
    },
    on: {
      "click": function ($event) {
        return _vm.onStart('stock');
      }
    }
  }, [_vm.luckyInfo?.count_options?.length > 1 && _vm.luckyList && _vm.luckyList[0] ? _c('div', {
    staticClass: "lucky-magni",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.setCountOption('stock');
      }
    }
  }, [_c('div', {
    staticClass: "lucky-magni-main"
  }, [_vm._v("x" + _vm._s(_vm.stockSelectCountOptions))])]) : _vm._e(), _c('div', {
    staticClass: "lucky-btn-main",
    style: {
      background: `url(${require(`@images/${_vm.theme}/lucky/lucky-btn2.png`)}) center/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "lucky-btn__title"
  }, [_vm._v("SPIN")]), !_vm.isstockLoading ? _c('div', {
    staticClass: "lucky-btn__value"
  }, [_vm.luckyInfo.stock.price_stock > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPSTOCK.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.stock.price_stock > 0 && _vm.userData.stock < _vm.luckyInfo.stock.price_stock ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.luckyInfo ? _vm.fmt_pre(_vm.luckyInfo.stock.price_stock) : "--"))])]) : _vm._e(), _vm.luckyInfo.stock.price_stock > 0 && _vm.luckyInfo.stock.price_coin > 0 ? [_vm._v(" + ")] : _vm._e(), _vm.luckyInfo.stock.price_coin > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPCOINS.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.stock.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.stock.price_coin ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.stock.price_coin)))])]) : _vm._e(), _vm.luckyInfo.stock.price_stock <= 0 && _vm.luckyInfo.stock.price_coin <= 0 ? _c('span', [_vm._v("--")]) : _vm._e()], 2) : _c('div', {
    staticClass: "lucky-btn__loading"
  }, [_c('div', {
    staticClass: "btn-loading"
  })])])]), _c('div', {
    staticClass: "lucky-btn",
    class: (!_vm.isFlag || _vm.luckyInfo.tap.price_stock > 0 && _vm.userData.tap < _vm.luckyInfo.tap.price_stock || _vm.luckyInfo.tap.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.tap.price_coin || _vm.luckyInfo.tap.price_tap > 0 && _vm.assetsList && _vm.assetsList?.[3].balance < _vm.luckyInfo.tap.price_tap) && 'active',
    style: {
      background: `url(${require(`@images/${_vm.theme}/new/machine/machine-btn2-bg.png`)}) center/auto 100% no-repeat`
    },
    on: {
      "click": function ($event) {
        return _vm.onStart('tap');
      }
    }
  }, [_vm.luckyInfo?.count_options?.length > 1 && _vm.luckyList && _vm.luckyList[0] ? _c('div', {
    staticClass: "lucky-magni",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.setCountOption('tap');
      }
    }
  }, [_c('div', {
    staticClass: "lucky-magni-main"
  }, [_vm._v("x" + _vm._s(_vm.tapSelectCountOptions))])]) : _vm._e(), _c('div', {
    staticClass: "lucky-btn-main",
    style: {
      background: `url(${require(`@images/${_vm.theme}/lucky/lucky-btn2.png`)}) center/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "lucky-btn__title"
  }, [_vm._v("SPIN")]), !_vm.istapLoading ? _c('div', {
    staticClass: "lucky-btn__value"
  }, [_vm.luckyInfo.tap.price_stock > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPSTOCK.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.tap.price_stock > 0 && _vm.userData.stock < _vm.luckyInfo.tap.price_stock ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.luckyInfo ? _vm.fmt_pre(_vm.luckyInfo.stotapck.price_stock) : "--"))])]) : _vm._e(), _vm.luckyInfo.tap.price_stock > 0 ? [_vm._v(" + ")] : _vm._e(), _vm.luckyInfo.tap.price_coin > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAPCOINS.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.tap.price_coin > 0 && _vm.userData.coin < _vm.luckyInfo.tap.price_coin ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.tap.price_coin)))])]) : _vm._e(), _vm.luckyInfo.tap.price_coin > 0 || _vm.luckyInfo.tap.price_coin > 0 ? [_vm._v(" + ")] : _vm._e(), _vm.luckyInfo.tap.price_tap > 0 ? _c('span', [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/new/TAP.png`),
      "alt": ""
    }
  }), _c('i', {
    style: {
      color: this.luckyInfo?.id > 0 && _vm.luckyInfo.tap.price_tap > 0 && _vm.assetsList && _vm.assetsList?.[3].balance < _vm.luckyInfo.tap.price_tap ? '#ff0808c4' : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.fmt_pre(_vm.luckyInfo.tap.price_tap)))])]) : _vm._e()], 2) : _c('div', {
    staticClass: "lucky-btn__loading"
  }, [_c('div', {
    staticClass: "btn-loading"
  })])])])]), _c('div', {
    staticClass: "lucky-balance"
  }, [_c('n-currency-two', {
    ref: "nCurrencyTwoRef",
    attrs: {
      "itemBg": "#0e2043",
      "isShowCoin": false,
      "showkeyFnc": () => _vm.popSignShow = true,
      "isShowTap": true,
      "showTapFnc": () => _vm.popUsdInviteShow = true
    }
  })], 1)])]), _c('div', {
    staticClass: "lucky-gift"
  }, [_c('div', {
    staticClass: "gifts-main page-main"
  }, [_c('div', {
    staticClass: "gifts-title"
  }, [_c('div', {
    staticClass: "gifts-title-btns"
  }, [_c('div', {
    staticClass: "btn-mygift",
    on: {
      "click": _vm.onOpenMarket
    }
  }, [_c('svg-icon', {
    staticClass: "getgems",
    attrs: {
      "name": "icon-getgems"
    }
  }), _c('div', [_vm._v("Market Price")])], 1), _c('div', {
    staticClass: "btn-mygift gift",
    on: {
      "click": _vm.onShowMyGift
    }
  }, [_vm._v("My Gift "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)])]), _c('div', {
    staticClass: "gifts-sub"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-sigh"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Collect all the Shards to get high-value GIFT for free ")])], 1), _vm.giftList ? [_vm.giftList.length > 0 ? [_c('transition-group', {
    staticClass: "gifts-list",
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterShowDaily
    }
  }, [_vm.giftList && _vm.giftList.length > 0 ? _vm._l(_vm.giftList, function (item, index) {
    return _c('div', {
      key: `gifts${index}`,
      staticClass: "gifts-item",
      attrs: {
        "data-index": index <= 50 ? index + 0.2 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowGiftDetail(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "gifts-item-main"
    }, [_c('div', {
      staticClass: "gifts-item-chip"
    }, [_c('div', {
      staticClass: "gifts-item-chip-main"
    }, [_c('img', {
      attrs: {
        "src": item.gift_thumb,
        "alt": ""
      }
    })])]), _c('div', {
      staticClass: "gifts-item-progress"
    }, [_c('div', {
      staticClass: "gifts-item-progress-main"
    }, [_c('div', {
      staticClass: "gifts-item-progress-bar"
    }, [_c('div', {
      staticClass: "bar",
      style: {
        transform: `translateX(-${(1 - item.shard_amount / item.required_shards) * 100}%)`
      }
    })])]), _c('div', {
      staticClass: "gifts-item-progress-text"
    }, [_vm._v(_vm._s(_vm.fmt_pre(item.shard_amount)) + "/" + _vm._s(_vm.fmt_pre(item.required_shards)))])])]), _c('div', {
      staticClass: "gift-item__name"
    }, _vm._l(Array.from({
      length: item.gift_level
    }, (_, i) => i + 1), function (_) {
      return _c('img', {
        attrs: {
          "src": require('@images/tapcoin/lucky/icon-star2.png'),
          "alt": ""
        }
      });
    }), 0)]);
  }) : _vm._e()], 2)] : _vm._e()] : _c('div', {
    staticClass: "gifts-loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])], 2)])]), _c('pop-usd-sign', {
    attrs: {
      "show": _vm.popSignShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popSignShow = $event;
      },
      "skip": () => (_vm.popSignShow = false, _vm.popUsdInviteShow = true)
    }
  }), _c('pop-usd-invite', {
    attrs: {
      "show": _vm.popUsdInviteShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popUsdInviteShow = $event;
      },
      "skip": () => (_vm.popUsdInviteShow = false, _vm.popSignShow = true)
    }
  }), _c('pop-prompt2', {
    attrs: {
      "isShadowClick": true,
      "className": "popMyGiftClass",
      "show": _vm.popMyGiftShow,
      "content": "html",
      "isBtnCancel": false,
      "isBtnConfirm": false,
      "title": "My Gifts"
    },
    on: {
      "update:show": function ($event) {
        _vm.popMyGiftShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-mygift"
  }, [_c('div', {
    ref: "popmygift",
    staticClass: "pop-mygift-main"
  }, [_vm.myGiftList ? [_vm.myGiftList.length > 0 ? [_c('transition-group', {
    staticClass: "pop-mygift-list",
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, _vm._l(_vm.myGiftList, function (item, index) {
    return _c('div', {
      key: `mygift${index}`,
      staticClass: "pop-mygift-item",
      attrs: {
        "data-index": index <= 50 ? index + 0.1 : 0
      }
    }, [_c('div', {
      staticClass: "pop-mygift-item-chip",
      style: {
        background: `url(${require('@images/tapcoin/lucky/gift-bg.png')}) center top/auto 100% no-repeat`
      }
    }, [_c('img', {
      attrs: {
        "src": item.gift_thumb,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "pop-mygift-item-info"
    }, [item.gift_name ? _c('div', {
      staticClass: "pop-mygift-item__name"
    }, [_vm._v(_vm._s(item.gift_name))]) : _vm._e(), item.gift_status == 0 ? _c('div', {
      staticClass: "pop-mygift-item__tip"
    }, [!item.gift_type ? [_vm._v("Will be distributed within 24 hours, please make sure tointeract with "), _c('em', {
      on: {
        "click": function ($event) {
          return _vm.onSkip(_vm.setting.botname);
        }
      }
    }, [_vm._v("@" + _vm._s(_vm.setting.botname))])] : [_vm._v("Will be distributed within 24 hours, please make sure tointeract with "), _c('em', {
      on: {
        "click": function ($event) {
          _vm.onSkip(_vm.adminName.charAt(0).toLowerCase() + _vm.adminName.slice(1));
        }
      }
    }, [_vm._v("@" + _vm._s(_vm.adminName))])]], 2) : _vm._e()]), _c('div', {
      staticClass: "pop-mygift-item-num"
    }, [item.gift_status == 2 ? _c('span', {
      staticStyle: {
        "color": "#2ed580"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok"
      }
    }), _vm._v("Sold")], 1) : item.gift_status == 0 ? _c('span', {
      staticStyle: {
        "color": "#ffc600"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-time"
      }
    }), _vm._v(" Issuing")], 1) : item.gift_status == 1 ? _c('span', {
      staticStyle: {
        "color": "#2ed580"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-ok"
      }
    }), _vm._v("Issued")], 1) : _vm._e(), item.gift_status == 2 ? _c('div', {
      staticClass: "pop-mygift-item__price"
    }, [_c('img', {
      attrs: {
        "src": require('@images/tapcoin/lucky/icon-star2.png'),
        "alt": ""
      }
    }), _vm._v("20")]) : _vm._e()])]);
  }), 0)] : _c('div', {
    staticClass: "pop-mygift-empty"
  }, [_vm._v("There's nothing here!")])] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])]), _c('pop-prompt2', {
    attrs: {
      "isShadowClick": true,
      "show": _vm.popGiftDetailShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popGiftDetailShow = $event;
      }
    }
  }, [_vm.rowGift ? _c('div', {
    staticClass: "pop-giftdetail"
  }, [_c('div', {
    staticClass: "pop-giftdetail__desc"
  }, [_vm._v(" Collect all the Shards to"), _c('br'), _vm._v(" get high-value GIFT for free ")]), _c('div', {
    staticClass: "pop-giftdetail__icon",
    style: {
      background: `url(${_vm.rowGift.gift_thumb}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "pop-giftdetail__title"
  }, [_vm._v(_vm._s(_vm.rowGift.gift_name))]), _c('div', {
    staticClass: "pop-giftdetail__market"
  }, [_c('div', {
    staticClass: "btn-market",
    on: {
      "click": _vm.onOpenMarket
    }
  }, [_c('svg-icon', {
    staticClass: "getgems",
    attrs: {
      "name": "icon-getgems"
    }
  }), _c('div', {
    staticClass: "btn-market__title"
  }, [_vm._v(" Market Price "), _c('span', _vm._l(Array.from({
    length: _vm.rowGift.gift_level
  }, (_, i) => i + 1), function (_) {
    return _c('img', {
      attrs: {
        "src": require('@images/tapcoin/lucky/icon-star2.png'),
        "alt": ""
      }
    });
  }), 0)])], 1)]), _vm.rowGift.progress ? _c('div', {
    staticClass: "pop-giftdetail-main"
  }, _vm._l(_vm.rowGift.progress, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-giftdetail-items"
    }, [_c('div', {
      staticClass: "pop-giftdetail-pro"
    }, [_c('div', {
      staticClass: "pop-giftdetail-ship",
      style: {
        background: `url(${require('@images/tapcoin/lucky/tapgiftshard.png')}) center top/auto 100% no-repeat`
      }
    }), _c('div', {
      staticClass: "gifts-item-progress"
    }, [_c('div', {
      staticClass: "gifts-item-progress-main"
    }, [_c('div', {
      staticClass: "gifts-item-progress-bar"
    }, [_c('div', {
      staticClass: "bar",
      style: {
        transform: `translateX(-${(1 - item / _vm.rowGift.required_shards) * 100}%)`
      }
    })])]), _c('div', {
      staticClass: "gifts-item-progress-text"
    }, [_vm._v(_vm._s(item) + "/" + _vm._s(_vm.rowGift.required_shards))])]), index == 0 && _vm.rowGift.time > 1 ? _c('div', {
      staticClass: "pop-giftdetail-tag"
    }, [_vm._v("x" + _vm._s(_vm.rowGift.time))]) : _vm._e()]), item >= _vm.rowGift.required_shards ? _c('div', {
      staticClass: "pop-giftdetail-btns ok"
    }, [_c('div', {
      staticClass: "btn btn-get",
      class: _vm.giftList[_vm.rowGift.index].isSellLoading && 'disable',
      on: {
        "click": function ($event) {
          return _vm.onShowGiftSell(item, 0);
        }
      }
    }, [item < _vm.rowGift.required_shards || !_vm.giftList[_vm.rowGift.index].isGetLoading ? [_vm._v(" Get")] : [_c('div', {
      staticClass: "circleLoading"
    })]], 2), _c('div', {
      staticClass: "btn btn-sell",
      class: _vm.giftList[_vm.rowGift.index].isGetLoading && 'disable',
      on: {
        "click": function ($event) {
          return _vm.onShowGiftSell(item, 1);
        }
      }
    }, [item >= _vm.rowGift.required_shards ? [!_vm.giftList[_vm.rowGift.index].isSellLoading ? [_vm._v(" Sell  "), item >= _vm.rowGift.required_shards ? [_c('img', {
      attrs: {
        "src": require('@images/tapcoin/lucky/icon-star.png'),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.fmt_pre(_vm.rowGift.recycling_stars)))] : _vm._e()] : [_c('div', {
      staticClass: "circleLoading"
    })]] : [_vm._v("Sell")]], 2)]) : _vm._e()]);
  }), 0) : _vm._e()]) : _vm._e()]), _c('pop-prompt2', {
    attrs: {
      "className": "popGamerewardBox",
      "isClose": false,
      "show": _vm.isPopResult,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": true,
      "confirmText": "Go head"
    },
    on: {
      "update:show": function ($event) {
        _vm.isPopResult = $event;
      },
      "confirm": _vm.popGamerewardConfirm
    }
  }, [_c('div', {
    staticClass: "pop-gamereward"
  }, [_c('div', {
    staticClass: "pop-gamereward__title"
  }, [_vm._v("Congratulations")]), _vm.selectRow ? _c('div', {
    staticClass: "pop-gamereward-list"
  }, [_c('div', {
    staticClass: "pop-gamereward-item"
  }, [_c('div', {
    staticClass: "pop-gamereward-item-giftshard"
  }, [_c('div', {
    staticClass: "pop-gamereward-item__title"
  }, [_vm._v("Shard Rewards(+"), _c('m-count-up', {
    attrs: {
      "endVal": Number(Object.values(_vm.selectRow.amount).reduce((sum, item) => sum + Number(item.amount || 0), 0))
    }
  }), _vm._v(")")], 1), _c('transition-group', {
    staticClass: "pop-gamereward-item-scroll",
    attrs: {
      "appear": "",
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterGameGiftShard
    }
  }, _vm._l(_vm.selectRow.amount, function (val, ke, index) {
    return _c('div', {
      key: `gamereward${index}`,
      staticClass: "pop-gamereward-item-chip",
      attrs: {
        "data-index": index <= 50 ? index + 0.2 : 0
      }
    }, [_c('div', {
      staticClass: "pop-gamereward-item-chip-icon"
    }, [_c('img', {
      attrs: {
        "src": val.thumb,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "pop-gamereward-item__name"
    }, [_c('span', [_vm._v(_vm._s(val.name))])]), _c('div', {
      staticClass: "pop-gamereward-item__num"
    }, [_vm._v("+"), _c('m-count-up', {
      attrs: {
        "endVal": Number(val.amount)
      }
    })], 1)]);
  }), 0)], 1)])]) : _vm._e()])]), _c('pop-prompt2', {
    attrs: {
      "className": "popGiftSellBox",
      "isShadowClick": !_vm.rowGiftSellContent || _vm.rowGiftSellContent.type != 'get2' || _vm.isPopGiftSellClose,
      "isClose": !_vm.rowGiftSellContent || _vm.rowGiftSellContent.type != 'get2' || _vm.isPopGiftSellClose,
      "show": _vm.popGiftSellShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popGiftSellShow = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "limit",
      fn: function () {
        return [_vm.rowGiftSellContent.type == 'sell' ? _c('div', {
          staticClass: "pop-giftSell__balance"
        }, [_c('span', [_vm._v("Balance: ")]), _c('img', {
          attrs: {
            "src": require(`@images/tapcoin/lucky/icon-star.png`),
            "alt": ""
          }
        }), _vm.assetsList && _vm.assetsList.length ? _c('em', [!_vm.isGiftSellUpStarBalance ? [_vm._v(" " + _vm._s(_vm._f("fmt_pre")(_vm.assetsList[0].balance)) + " ")] : _c('m-count-up', {
          attrs: {
            "endVal": Number(_vm.assetsList[0].balance)
          }
        })], 2) : _vm._e()]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm.rowGiftSellContent ? _c('div', {
    staticClass: "pop-giftSell"
  }, [_c('div', {
    staticClass: "pop-giftSell__title",
    domProps: {
      "innerHTML": _vm._s(_vm.rowGiftSellContent.title)
    }
  }), _c('div', {
    staticClass: "pop-giftSell__sub",
    domProps: {
      "innerHTML": _vm._s(_vm.rowGiftSellContent.content)
    }
  }), _c('div', {
    staticClass: "pop-giftSell-btns"
  }, [_vm.giftList[this.rowGift.index].isSellLoading || _vm.giftList[this.rowGift.index].isGetLoading ? _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _c('div', {
    staticClass: "btn",
    class: _vm.rowGiftSellContent.type,
    domProps: {
      "innerHTML": _vm._s(_vm.rowGiftSellContent.btn)
    },
    on: {
      "click": function ($event) {
        return _vm.rowGiftSellContent.btnSkip(_vm.rowGiftSellContent.type);
      }
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };